import AnalyticsEvents from "./analyticsevents";

export default class AnalyticsEngineBase {
  _analyticsManagerBase = null;

  constructor(analyticsManagerBase, options = {}) {
    this._analyticsManagerBase = analyticsManagerBase;
    this._events = AnalyticsEvents;
    this._options = options;
    // subscribe here on the relevant events
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/analyticsenginebase.js